import { render, staticRenderFns } from "./comp_Hook-ShopApp-HotsaleTimer.vue?vue&type=template&id=60b5d30b&scoped=true&"
import script from "./comp_Hook-ShopApp-HotsaleTimer.vue?vue&type=script&lang=js&"
export * from "./comp_Hook-ShopApp-HotsaleTimer.vue?vue&type=script&lang=js&"
import style0 from "./comp_Hook-ShopApp-HotsaleTimer.vue?vue&type=style&index=0&id=60b5d30b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b5d30b",
  null
  
)

export default component.exports